<template>
  <div class="contract-reminder">
    <!-- 标题区域 -->
    <div class="reminder-header">
      <h3 class="title">合同到期提醒</h3>
      <div class="index-number-describe margin-top-sm" @click="_toOwner">
        查看全部合同
      </div>
    </div>

    <!-- 表头 -->
    <div class="table-header">
      <div class="table-cell tenant-name">租户名称</div>
      <div class="table-cell room-number">房间号</div>
      <div class="table-cell expire-date">到期日期</div>
      <div class="table-cell remaining-days">剩余天数</div>
    </div>

    <!-- 列表内容 -->
    <ul id="pool" class="contract-list">
      <!-- 无数据状态 -->
      <li v-if="!displayList || displayList.length === 0" class="no-data">
        暂无数据
      </li>

      <!-- 合同列表项 -->
      <li
        v-else
        v-for="item in displayList"
        :key="item.contractId"
        class="contract-item"
      >
        <div class="table-cell tenant-name">{{ item.partyB }}</div>
        <div class="table-cell room-number">{{ item.fj }}</div>
        <div class="table-cell expire-date">{{ formatDate(item.endTime) }}</div>
        <div
          class="table-cell remaining-days"
          :class="{ expired: item.syts < 0 }"
        >
          {{ formatRemainingDays(item.syts) }}
        </div>
      </li>
    </ul>

    <!-- 查看全部按钮 -->
    <div class="view-all-container" v-if="contractList.length > 5">
      <button class="view-all-btn">查看全部合同</button>
    </div>
  </div>
</template>

<script>
import { getNotepadList } from "@/api/index/propertyIndexApi";

export default {
  name: "ContractExpireReminder",
  data() {
    return {
      contractList: [], // 存储所有数据
      scrollInterval: null,
      scrollTopValue: 0,
      scrollDirection: true,
    };
  },
  computed: {
    // 计算属性：只返回前5条数据
    displayList() {
      return this.contractList.slice(0, 5);
    },
  },
  mounted() {
    this._loadPropertyIndexNotices(); // 仅检查滚动，不触发加载
  },
  beforeDestroy() {
    if (this.scrollInterval) {
      clearInterval(this.scrollInterval);
    }
    window.removeEventListener("resize", this.checkPoolScroll);
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "--";
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString; // 日期无效时返回原始值
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    formatRemainingDays(syts) {
      // 先判断是否为有效数字
      if (syts === undefined || syts === null) return "--";
      // 转换为数字类型
      const days = Number(syts);
      if (isNaN(days)) return "--";
      return days < 0 ? "已过期" : `${days}天`;
    },
    _toOwner() {
      this.$router.push("/pages/admin/expirationContractManage");
    },
    async _loadPropertyIndexNotices() {
      const param = {
        page: 1,
        row: 500,
        communityId: this.getCommunityId(),
      };

      try {
        const res = await getNotepadList(param);
        if (res.code === 0) {
          this.contractList = res.data;
          this.$nextTick(() => this.checkPoolScroll());
        } else {
          console.error("获取合同列表失败:", res.msg);
        }
      } catch (error) {
        console.error("请求失败处理", error);
      }
    },
    checkPoolScroll() {
      const element = document.getElementById("pool");
      if (!element) return;

      const clientHeight = element.clientHeight;
      const scrollHeight = element.scrollHeight;

      // 只有内容超出容器高度时才启用滚动
      if (scrollHeight > clientHeight) {
        if (!this.scrollInterval) {
          this.scrollInterval = setInterval(this.poolScroll, 3000);
        }
      } else {
        clearInterval(this.scrollInterval);
        this.scrollInterval = null;
      }
    },
    poolScroll() {
      const element = document.getElementById("pool");
      if (!element) return;

      const clientHeight = element.clientHeight;
      const scrollHeight = element.scrollHeight;
      const maxScroll = scrollHeight - clientHeight;

      // 滚动逻辑优化：每次滚动一个行高
      if (this.scrollDirection) {
        this.scrollTopValue += 45; // 行高固定为45px
        if (this.scrollTopValue >= maxScroll) {
          this.scrollTopValue = maxScroll;
          this.scrollDirection = false;
        }
      } else {
        this.scrollTopValue -= 45;
        if (this.scrollTopValue <= 0) {
          this.scrollTopValue = 0;
          this.scrollDirection = true;
        }
      }

      element.scrollTop = this.scrollTopValue;
    },
  },
};
</script>

<style lang="scss" scoped>
.index-number-describe {
  font-size: 12px;
  color: #999;
}
.margin-top-sm {
  margin-top: 5px;
}
.index-number-describe {
  font-size: 12px;
  color: #1890ff;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
/* 样式保持不变 */
.contract-reminder {
  background: #fff;
  border-radius: 4px;
  padding: 15px;
  height: 100%;
  box-sizing: border-box;

  // 头部样式
  .reminder-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;

    .title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin: 0;
    }

    .calendar-view {
      font-size: 12px;
      color: #409eff;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  // 表格头部
  .table-header {
    display: flex;
    background-color: #f5f7fa;
    border-radius: 4px 4px 0 0;
    font-weight: 500;

    .table-cell {
      padding: 12px 10px;
      font-size: 13px;
      color: #666;
      text-align: left;
    }

    .tenant-name {
      width: 20%;
    }

    .room-number {
      width: 40%;
    }

    .expire-date {
      width: 20%;
    }

    .remaining-days {
      width: 15%;
    }
  }

  // 列表样式
  .contract-list {
    height: 240px; // 调整高度留出按钮空间
    overflow-y: auto;
    padding: 0;
    margin: 0;
    list-style: none;
    border: 1px solid #f0f0f0;
    border-top: none;
    border-radius: 0 0 4px 4px;

    // 无数据状态
    .no-data {
      color: #999;
      text-align: center;
      padding: 40px 0;
      font-size: 14px;
    }

    // 列表项样式
    .contract-item {
      display: flex;
      align-items: center;
      height: 45px;
      border-bottom: 1px solid #f5f5f5;

      &:last-child {
        border-bottom: none;
      }

      .table-cell {
        padding: 0 10px;
        font-size: 13px;
        color: #333;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .tenant-name {
        width: 20%;
      }

      .room-number {
        width: 40%;
      }

      .expire-date {
        width: 20%;
      }

      .remaining-days {
        width: 15%;
        &.expired {
          color: #ff4d4f; // 过期状态红色
        }
      }
    }
  }

  // 查看全部按钮
  .view-all-container {
    display: flex;
    justify-content: center;
    margin-top: 15px;

    .view-all-btn {
      padding: 6px 20px;
      background-color: #f5f7fa;
      color: #666;
      border: none;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background-color: #e9ecef;
        color: #333;
      }
    }
  }
}
</style>
